<a
	*ngFor="let item of menuItems; trackBy: lobbyTrackBy"
	class="obg-product-selector-item"
	[attr.test-id]="'menu.' + item.key"
	[attr.data-test-id]="'menu.' + item.key"
	[obgRouteLink]="{ route: item.route, url: item.link?.url }"
	[obgRouteLinkActive]="item.route"
	[obgScrollIntoView]="isCurrentRoute(item)"
	[obgRouteLinkActiveOptions]="linkActiveOptions"
	(click)="onItemClick(item)"
>
	<span [class]="item.iconTag + ' ' + 'obg-product-selector-icon'"></span>
	<span class="obg-product-selector-label">{{ item.title | translate }}</span>
</a>
